<ion-header #header>
  <ion-toolbar color="light">
    <ion-buttons slot="start">
      <ion-button (click)="dismissModal()">
        <ion-icon class="back-icon" name="chevron-back"></ion-icon>
      </ion-button>
    </ion-buttons>
    <ion-title>
      <app-offline-indicator></app-offline-indicator>
      {{ 'BLAST.redeem.title' | translate }}
    </ion-title>
  </ion-toolbar>
</ion-header>

<ion-content class="full-width" color="light" #content>
  <div>
    <ion-img class="header-img center" src="./assets/wedding/img/blast/redeem/header.webp"></ion-img>
  </div>

  <div class="ion-margin ion-padding-top ion-text-center">
    <div class="ion-margin">
      <ion-text class="font-20" color="dark">
        {{ 'BLAST.redeem.intro' | translate }}
      </ion-text>
    </div>

    <div class="ion-margin">
      <ion-text class="font-12" color="dark">
        {{ 'BLAST.promo.sms_intro' | translate }}
      </ion-text>
    </div>
  </div>

  <div class="ion-padding-horizontal">
    <ion-card class="ion-padding" (click)="appRate()" button>
      <div class="ion-text-center">
        <ion-text class="font-12 font-bold" color="dark">{{ 'STEP.1' | translate }}</ion-text>
      </div>
      <div class="ion-text-center">
        <ion-img class="step1 center" src="./assets/wedding/img/blast/redeem/step1.webp"></ion-img>
      </div>
      <div class="ion-text-center">
        <ion-text class="font-14" color="dark">{{ 'BLAST.redeem.step1' | translate }}</ion-text>
      </div>
    </ion-card>
  
    <ion-card class="ion-padding" (click)="redeemBlastCreditCall()" *ngIf="showStep2" button>
      <div class="ion-text-center">
        <ion-text class="font-12 font-bold" color="dark">{{ 'STEP.2' | translate }}</ion-text>
      </div>
      <div>
        <ion-img class="step2 center" src="./assets/wedding/img/blast/redeem/step2.webp"></ion-img>
      </div>
      <div class="ion-text-center">
        <ion-text class="font-14" color="dark" [innerHtml]="'BLAST.redeem.step2' | translate"></ion-text>
      </div>
    </ion-card>
  </div>

</ion-content>